import React, {useEffect, useRef, useState} from 'react';
import format from 'date-fns/format';
import useFormApi from '../docAutomation/useFormApi'
import SarasTrans from '../../../library/notifications/SarasTrans';
import ActionButton from '../../../library/input/buttons/button/SarasButton2';
import SarasMenu from '../../../library/repeater/menu/SarasMenu';
import SarasMenuItem from '../../../library/repeater/menu/SarasMenuItem';
import { SarasMap, Icon } from '../../../library/decor/SarasIcons';
import * as htmlToImage from 'html-to-image';
import InsightsCriteria from './InsightsCriteria';
import SarasDateRangePicker from '../../../library/input/datePicker/SarasDateRangePicker';
import SarasDialogFullScreen from '../../../library/container/popup/SarasDialogFullScreen';
import DocSearchContainer from '../docSearch/DocSearchContainer';
import { getValueFromKey } from '../docAutomation/formFunctions';
import coreSettings from '../../../helper/coreSetting';
import { multiLingualEncoding, parseDate } from '../../../helper/uiFunctions';
import { checkOptionAvailable } from './insights_functions';
import { buildCriteriaValueFromJsonList, buildSearchCriteria, buildSearchCriteriaFromString, srcBldrDefaultCriteriaRange } from '../docSearch/components/DocSCFunctions';

const regionMenu = [
    {"world": "World"}, {"005": "South America"}, {"009": "Oceania"}, {"013": "Central America"}, {"021": "North America"},
    {"019": "Americas"}, {"029": "Caribbea"}, {"002": "All of Africa"}, {"017": "Central Africa"}, {"015": "Northern Africa"},
    {"018": "Southern Africa"}, {"150": "Europe"}, {"154": "Northern Europe"}, {"155": "Western Europe"}, {"039": "Southern Europe"},
    {"030": "Eastern Asia"}, {"034": "Southern Asia"}, {"035": "Asia/Pacific region"}, {"142": "Asia"}, {"143": "Central Asia"},
    {"145": "Middle East"}, {"151": "Northern Asia"}
]

const downloadMenu = [
    {"graph": "Download Graph"},
    {"summary": "Download Summary Report"}
]

const InsightsView = (props) => {
    const { 
        insightKey, viewData, viewMap, sycnhOption, onOptionChanged, sycnhReload,
        sycnhDate, deviceInfo
        } = props;

    const [insightData, setInsightData] = useState(null);
    // const [imageSrc, setImageSrc] = useState(null);
    const anchorRef = React.useRef(null);
    const rootRef = useRef(null);
    const parentScrollRef = React.useRef(null);
    
    //string based criteria value - output from the criteria editor
    const [insightCriteriaValue, setInsightCriteriaValue] = useState(null);

    const [isFullScreen, setIsFullScreen] = useState(false);

    const [isVisible, setIsVisible] = useState(!props.loadOnVisible); // If not using lazy, default to visible

    //complete data required for criteria editor: list of parsed criteria, fileds list, conditions list
    const [insightCriteriaData, setInsightCriteriaData] = useState(null);
    const [drillDownConfig, setDrillDownConfig] = useState({});

    // const [pendingDate, setPendingDate] = useState(null);
    const [pendingOption, setPendingOption] = useState(null);
    const [insightOption, setInsightOption] = useState(null);
    const [insightViewKey, setInsightViewKey] = useState(null);
    const [insightRegionKey, setInsightRegionKey] = useState('world');
    const [isLoading, setIsLoading] = useState(false);
    const [showCriteriaEditor, setShowCriteriaEditor] = useState(false);
    const [insightDate, setInsightDate] = useState({
      startDate: new Date(),
      endDate: new Date(),
    });

    const formApi = useFormApi();

    useEffect(() => {
        if (!props.loadOnVisible) return; // If not lazy, skip

        const observer = new window.IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect(); // Only load once
            }
        },
        { threshold: 0.1 }
        );
        if (rootRef.current) observer.observe(rootRef.current);

        return () => observer.disconnect();
    }, [props.loadOnVisible]);
    
    const synchCriteriaAction = () => {
        // console.log("layout response view data", "refresh criteria 1", sycnhDate, insightData, insightCriteriaValue);

        //fire only if the current criteria is different from new criteria
        //and if date filter key is not blank
        if(sycnhDate && insightData && insightData.DateFilterKey) {
            // console.log("layout response view data", "refresh criteria 2", sycnhDate, insightData, insightCriteriaValue);
            //merge the date filter key with the current criteria value
            onDateCriteriaChange(sycnhDate);
        }
        // else if(sycnhDate) {
        //     setPendingDate(sycnhDate);
        // }
    };

    useEffect(synchCriteriaAction, [sycnhDate]);

    const synchReloadAction = () => {
        if(sycnhReload && !isLoading) {
            onRefreshViewClick();
        }
    };

    useEffect(synchReloadAction, [sycnhReload]);

    const synchOptionSelection = () => {
        if(sycnhOption && insightData && sycnhOption !== insightOption) {
            if(checkOptionAvailable(insightData.ViewData, sycnhOption)){
                setInsightOption(sycnhOption);
            }
        }
        else if(sycnhOption && sycnhOption !== insightOption) {
            setPendingOption(sycnhOption);
        }
        
    };

    useEffect(synchOptionSelection, [sycnhOption]);

    const loadView = () => {
        if(isVisible && !insightData) {
            // console.log("initial layout load view fired", insightKey);
            
            let layoutAction = { actionId: "show", actionName: "appInsight", 
                viewDataReload: 0,
                actionParam: 
                {
                    'content-type':'insight-view',
                    'view-key': insightKey,
                    'view-criteria': insightCriteriaValue
                },
                containerKey:""};
            formApi.runGenericAction(layoutAction, "appInsight", null, null, null, "", "", 0, onViewSuccess);
        }
    };

    useEffect(loadView, [isVisible, insightData, insightKey]);

    const onViewSuccess = (action, containerKey, rowKey, headerKey, response) => {
        // console.log("layout response view data", response);

        setIsLoading(false);

        if(response.mainViewDataV5){
            const _insightViewData = response.mainViewDataV5.viewData;
            const _insightViewKey = response.mainViewDataV5.viewKey;
            
            setInsightCriteriaData(response.mainViewData);
            setInsightData(_insightViewData);
            setInsightViewKey(_insightViewKey);
            
            if(pendingOption && checkOptionAvailable(_insightViewData.ViewData, pendingOption)){
                setInsightOption(pendingOption);
                setPendingOption(null);
            }
            else
            {
                setInsightOption(_insightViewData.DefaultOption);
            }

            initialiseCriteriaValue(response.mainViewData, _insightViewData);

            // if(pendingDate && _insightViewData.DateFilterKey) {
            //     setTimeout(() => {
            //         // merge the date filter key with the current criteria value
            //         let criteria = updateInsightDate(_insightViewData, insightCriteriaValue, response.mainViewData, pendingDate);
            //         setPendingDate(null);
            //         onRefreshViewClick(null, criteria);
            //     }, 1000);
            // }
        }
    }

    const initialiseCriteriaValue = (data, newInsightData) => {
        let scList = getValueFromKey(data, "childViews.criteriaView.viewRows", null);

        let criteriaValue = buildCriteriaValueFromJsonList(scList);

        //extract the date filter key from the criteria value
        extractDateFilterRange(newInsightData, scList, criteriaValue);

        setInsightCriteriaValue(criteriaValue);
    }

    const extractDateFilterRange = (data, scList, criteria) => {
        if(!data || !data.DateFilterKey) return;

        if(!scList){
            let fieldsList = getValueFromKey(insightCriteriaData, "childViews.fieldView.viewRows", null);

            //reverse the criteria list to get the date filter key
            scList = buildSearchCriteriaFromString(criteria || insightCriteriaValue, fieldsList);
        }

        let fieldKey = data.DateFilterKey;
        let criteriaObj = Object.values(scList).find(obj => obj.dataList.fieldKey === fieldKey);

        if(criteriaObj) {
            //update the date range
            let startDate = parseDate(criteriaObj.dataList.criteria1).toDate();
            let endDate = parseDate(criteriaObj.dataList.criteria2).toDate();

            if(startDate && endDate) {
                setInsightDate({
                    startDate: startDate,
                    endDate: endDate
                });
            }
        }
    }

    const updateInsightDate = (newInsightData, criteriaValue, data, newDateRange) => {
        let updatedInsightData = newInsightData || insightData;
        
        if(!updatedInsightData.DateFilterKey) return;

        let newCriteriaValue = criteriaValue || insightCriteriaValue;

        let criteriaData = data || insightCriteriaData;

        let fieldsList = getValueFromKey(criteriaData, "childViews.fieldView.viewRows", null);

        //reverse the criteria list to get the date filter key
        let scList = buildSearchCriteriaFromString(newCriteriaValue, fieldsList);

        //search for the criteriaObj from scList that matches the date filter key
        let fieldKey = updatedInsightData.DateFilterKey;
        let criteriaObj = Object.values(scList).find(obj => obj.dataList.fieldKey === fieldKey);

        //update the sclist with the new date range and then call refresh view
        let startDate = format(newDateRange.startDate, coreSettings.currentDateLocale);
        let endDate = format(newDateRange.endDate, coreSettings.currentDateLocale);

        let newCriteria = buildSearchCriteria(criteriaObj, fieldKey, srcBldrDefaultCriteriaRange, 
                startDate, endDate, fieldsList);

        scList[newCriteria.rowKey] = newCriteria;

        //convert back the criteria to the string
        return buildCriteriaValueFromJsonList(scList);
    }

    const onCriteriaEditorShow = () => {
        setShowCriteriaEditor(true);
    }

    const onDateCriteriaChange = (newDate) => {
        setInsightDate(newDate);

        let criteria = updateInsightDate(null, null, null, newDate);

        onRefreshViewClick(null, criteria);
    }

    const onCriteriaApply = (criteria) => {
        setShowCriteriaEditor(false);

        // console.log("layout response view data", newCriteria);
        setInsightCriteriaValue(criteria);

        //extract the date filter key from the criteria value
        extractDateFilterRange(insightData, null, criteria);

        //apply criteria
        onRefreshViewClick(null, criteria);
    }

    const onCriteriaClose = () => {
        setShowCriteriaEditor(false);
    }

    const onFullScreenViewClick = () => {
        setIsFullScreen(prev => {
            // If we are exiting fullscreen, clear drilldown config
            if (prev) setDrillDownConfig({});
            return !prev;
        });
    }

    const onRefreshViewClick = (e, criteria) => {

        // console.log("layout response view data", "refresh criteria 3", criteria, insightCriteriaValue);
        
        setIsLoading(true);

        let layoutAction = { actionId: "show", actionName: "appInsight", 
            viewDataReload: 1,
            actionParam: 
            {
                'content-type':'insight-view',
                'view-key': viewData.dataList.vk,
                'view-criteria': criteria === null || criteria === undefined ? insightCriteriaValue : criteria
            }, 
            containerKey:""};

        formApi.runGenericAction(layoutAction, "appInsight", null, null, null, "", "", 0, onViewSuccess);
    }

    const onDownloadViewClick = (e, index) => {

        let downloadKey = Object.keys(downloadMenu[index])[0];

        if (downloadKey === 'graph') {

            let node = anchorRef.current;

            // console.log("layout response view data", insightData, anchorRef);

            htmlToImage.toBlob(node, { quality: 1 })
            .then(function (dataUrl) {
                // setImageSrc(dataUrl);
                // console.log("layout response view imageSrc2", dataUrl);

                const url = window.URL.createObjectURL(dataUrl);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", insightData.Title); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        }
        else if (downloadKey === 'summary') {
            //create print action on summary report click
            let layoutAction = { actionId: "print", actionName: "appInsight", 
                viewDataReload: 0,
                actionParam: 
                {
                    'content-type':'insight-print-summary',
                    'view-key': viewData.dataList.vk,
                    'view-criteria': insightCriteriaValue
                },
                containerKey:""};
            formApi.runGenericAction(layoutAction, "appInsight", null, null, null, "", "", 0, onViewSuccess);
        }
    }

    const onChangeOptionClick = (event, index) => {
        if(!insightData) return;
        // console.log("layout response view data", "onChangeOptionClick", index, insightData.ViewData);
        let value = createDDList(insightData.ViewData)[index].val;
        setInsightOption(value);

        if(onOptionChanged) onOptionChanged(value);
    }

    const onRegionChangeClick = (e, index) => {
        let regionKey = Object.keys(regionMenu[index])[0];

        setInsightRegionKey(regionKey);
    }

    const createDDList = (viewData) => {
        
        let list = [];

        if(!insightData) return;

        let dataArray = Object.keys(viewData);

        if(dataArray.length > 0)
        {
            for (var i = 0; i < dataArray.length; i++) {
                let dataKey = `By ${dataArray[i]}`;
                let data = dataArray[i];
                list.push({key: dataKey, val: data});
            }
        }

        return list;
    }

    const getDataMap = (data) => {
        //as per the information in the data row that is clicked, get the data map
        // console.log("insight data map", insightData.DataMap, data);

        //to complete the testing, return the first data map

        if(insightData && insightData.DataMap)
        {
            let keys = Object.keys(insightData.DataMap);

            //if there is only one data map, return that, otherwise return the one where StaticSeriesIdentifier matches the value in data
            if(keys.length > 1 && data && data.dataColName){
                let matchedKey = keys.find(key => insightData.DataMap[key].StaticSeriesIdentifier === data.dataColName);

                if(matchedKey){
                    return insightData.DataMap[matchedKey];
                }
            }
            
            //default to first key
            if(insightData && insightData.DataMap && keys.length > 0){
                return insightData.DataMap[keys[0]];
            }
        }

        return null;
    }

    const onDataSelect = (data) => {
        let datamap = getDataMap(data);

        if(!datamap){
            //show message to user saying Click to Drill Down not available
            return;
        }

        let clickFilter = [];

        clickFilter.push(insightCriteriaValue);

        if(datamap.SeriesFilterKey && data.dataColName){
            clickFilter.push(`${datamap.SeriesFilterKey} = ${multiLingualEncoding(data.dataColName)}`);
        }
        
        if(datamap.RowFilterKey && data.dataRow && data.dataRow.length > 0){
            clickFilter.push(`${datamap.RowFilterKey} = ${multiLingualEncoding(data.dataRow[0])}`);
        }

        let newInsightClickCriteria = clickFilter.join(",");

        const initialConfig = { 
            initialCriteria: newInsightClickCriteria, 
            resetCriteria: 1,
            groupKey: datamap.SearchTemplateKey,
            docTypeId: datamap.DocumentTypeId,
        }

        // console.log("chart section selected:", insightData.DataMap, data, initialConfig);

        setDrillDownConfig(initialConfig);
    }

    // console.log("layout response view", viewData.dataList.vk);
    const renderDynamicView = () => {
        let DynamicComponent = viewMap[insightViewKey];

        if(!DynamicComponent)
        {
            DynamicComponent = viewMap["vInsightGraphView"];
        }

        if(!DynamicComponent)
        {
            return null;
        }
        else
        {
            // console.log("insights data", insightData );

            if(isFullScreen)
            {
                return (
                    <div className='uiInsightFullScreenView' ref={parentScrollRef} style={{height: deviceInfo.screenHeight - 100, overflow: 'scroll'}}>
                        <div style={{height: drillDownConfig && drillDownConfig.docTypeId ? "250px" : "100%"}}>
                            <DynamicComponent 
                                viewData={insightData} activeOption={insightOption} mapRegionKey={insightRegionKey}
                                deviceInfo={deviceInfo}
                                onSelect={onDataSelect} isDrillDownMode={drillDownConfig && drillDownConfig.docTypeId ? 1 : 0}
                            />
                        </div>
                        {drillDownConfig && drillDownConfig.docTypeId ? <>
                            <DocSearchContainer 
                                enableSelect={false} enableDefaultActions={false} 
                                docTypeId={drillDownConfig.docTypeId} 
                                initialConfig={drillDownConfig} isRefresh={1}
                                parentScrollRef={parentScrollRef}
                                isEmbedded={true}/> 
                        </> : null}
                    </div>
                )
            }
            else
            {
                return (
                    <>
                        <DynamicComponent viewData={insightData} 
                            deviceInfo={deviceInfo}
                            activeOption={insightOption} mapRegionKey={insightRegionKey}/>
                    </>
                )
            }
        }
    }

    const renderTopActionView = (enableActions = true, showTitle = true) => {
        let DropdownIcon = Icon['arrowmenu'];

        let dataList = createDDList(insightData.ViewData);

 // Choose icon and text based on state
        const fullScreenIcon = isFullScreen ? 'fullscreen_exit' : 'fullscreen';
        const fullScreenText = isFullScreen ? "Exit Full Screen" : "Full Screen";
        const fullScreenTooltip = isFullScreen ? "Exit Full Screen Mode" : "Full Screen Mode";

        return (
            <div className='uiInsightViewActionContainer uiFlexBoxDistributed'>
                <div className='uiInsightViewActionLeft uiFlexBox3'>
                    {showTitle ? <span className='uiInsightTitle'>{insightData.Title}</span> : null}
                    {enableActions && showTitle ? <SarasMenu menuTrigger={
                        <span className='uiInsightTitle uiFlexBox3 uiHover saras-tour-insight-view-options'>
                            {insightOption && <SarasTrans value={`By ${insightOption}`} /> } <DropdownIcon className='uiBrandColor1'/>
                        </span>
                        }
                        dataList={dataList} menuItem={SarasMenuItem}
                        onSelection={onChangeOptionClick}
                        hideTriggerIfNoOptions={1}
                        minimumOptionsToDisplayTrigger={2}>
                    </SarasMenu> : null}
                </div>
                {enableActions && (insightData.ViewOptions?.enableFullScreenMode || (0 === 1 && (!deviceInfo.activateMobileView || isFullScreen))) ?
                <div className='uiFlexBox'>
                    <ActionButton onClick={onFullScreenViewClick} text={fullScreenText} 
                        tooltip={fullScreenTooltip}
                        icon={fullScreenIcon} className={'uiLink uiIcon saras-tour-insight-view-action-full-screen'} />
                </div>
                : null}
            </div>
        );
    }

    const renderBottomActionView = () => {
        let DownloadIcon = Icon['download'];

        return (
            <div className='uiInsightViewActionContainer uiFlexBox uiFlexBoxBaseLine'>
                <div className='uiInsightViewActionLeft uiFlexBox uiFlexBoxBaseLine saras-tour-insight-view-action-date'>
                    {insightData.DateFilterKey ? 
                        <SarasDateRangePicker value={insightDate} deviceInfo={deviceInfo} onChange={onDateCriteriaChange}/>
                        : " "
                    }
                </div>
                <div className='uiInsightViewActionRight uiFlexBox uiFlexBoxBaseLine'>
                    {
                        insightData.ViewOptions?.enableRegionFilter || 0 === 1 ?
                            <SarasMenu menuTrigger={<span className='uiLink'>
                                                        <SarasMap className='uiIcon'/>
                                                    </span>
                                                    } 
                                dataList={regionMenu} menuItem={SarasMenuItem} onSelection={onRegionChangeClick}></SarasMenu>
                        : null
                    }
                    {
                        insightData.ViewOptions?.enableDownload || (0 === 1 && false) ?
                            <SarasMenu menuTrigger={<span className='uiHoverRound uiLink'>
                                                    <DownloadIcon className='uiIcon'/>
                                                </span>
                                                } 
                            dataList={downloadMenu} menuItem={SarasMenuItem} onSelection={onDownloadViewClick}></SarasMenu>
                        : null
                    }
                    {
                        insightData.ViewOptions?.enableCriteriaEditor || 0 === 1 ?
                        <ActionButton onClick={onCriteriaEditorShow} text="Edit Filter" icon="search" 
                            tooltip="Edit the insights criteria"
                            className="uiLink uiIcon saras-tour-insight-view-action-filter"/>
                            : null
                    }
                    <ActionButton onClick={onRefreshViewClick} text="Reload Data" 
                            tooltip="Refresh insights data"
                            icon="refresh" className={`${isLoading ? 'uiRotating' : ''} uiLink uiIcon saras-tour-insight-view-action-refresh`} />
                </div>
            </div>
        );
    }

    if(insightData)
    {
        const enableActionView = (insightData.ViewOptions?.enableActionView ?? 1) === 1;
        const showTitle = (insightData.ViewOptions?.hideTitle ?? 0) !== 1;
        const contentClassName = showTitle || enableActionView ? 'uiInsightViewContent' : 'uiInsightViewContentNoAction';

        return (
            <SarasDialogFullScreen isFullScreenMode={isFullScreen}>
                {showCriteriaEditor ? 
                <InsightsCriteria viewData={insightCriteriaData} 
                report={insightKey}
                onCriteriaApply={onCriteriaApply}
                onCriteriaClose={onCriteriaClose} />
                :
                <div className={`uiInsightView ${insightData.ViewOptions?.viewContainerClass || 'uiInsightViewWhite'} ${isFullScreen ? 'uiInsightView--fullscreen-anim' : ''}`}>
                    {showTitle || enableActionView ?
                        <div className='uiInsightViewActionTop'>
                            {renderTopActionView(enableActionView, showTitle)}
                        </div>
                    : null}
                    <div ref={anchorRef} 
                        className={contentClassName}
                    >
                        <div className="uiInsightDynamicViewWrapper">
                            {renderDynamicView()}
                        </div>
                    </div>
                    {
                        enableActionView ?
                            <div className='uiInsightViewActionBottom'>
                                {renderBottomActionView()}
                            </div>
                        : null
                    }
                </div>
                }
            </SarasDialogFullScreen>
        )
    }

    //load placeholder
    return (
        <div ref={rootRef} className="uiInsightView uiInsightView--placeholder">
            <div style={{ padding: 24, textAlign: "center", color: "#aaa" }}>
            Loading insight...
            </div>
      </div>
    );
}

export default InsightsView;
